import { useContext } from 'react';
import useAccount from '@/hooks/useAccount';
import Button from '@/components/Button/Button';
import Link from '@/helpers/Link';
import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { viewportContext } from '@/context/viewport.context';

export default function HeaderMenu({ classes, t, onLogout }) {
  const { account } = useAccount();
  const { isLoggedIn } = account;
  const { isMobileOrTablet } = useContext(viewportContext);

  if (!isLoggedIn || isMobileOrTablet) return null;

  const isSystemAdmin = !!account.data?.is_admin;

  return (
    <div className="d-none d-xl-inline-block">
      <Dropdown data-cy="header-dropdown-account">
        <Dropdown.Toggle as="div" className={`${classes.accountToggle} accountToggle`}>
          <FontAwesomeIcon className={classes.accountIcon} icon={['fa', 'user']} aria-hidden="true" />
          <Button
            type={'link'}
            icon={{ style: 'fa', font: 'caret-down', position: 'right' }}
            additionalClasses={`${classes.accountBtn} accountBtn`}
            text={t('Account')}
          />
        </Dropdown.Toggle>
        <Dropdown.Menu popperConfig={{ strategy: 'fixed' }} renderOnMount>
          <Dropdown.Item as={Link} href="/settings">
            {t('Settings')}
          </Dropdown.Item>
          {isSystemAdmin && <Dropdown.Item href={'/admin'}>{t('Admin')}</Dropdown.Item>}
          <Dropdown.Item data-cy="header-dropdown-item-logout" onClick={onLogout}>
            {t('Logout')}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
